<template>
  <div class="container">
    <IndexMapGis />
  </div>
</template>

<script>
import IndexMapGis from './modules/IndexMapGis'

export default {
  name: 'IndexMap',
  components: {
    IndexMapGis
  },

  created () {
    this.setSystemName()
  },
  mounted () {
    document.body.classList.add('index-map-page-active')
  },
  beforeDestroy () {
    document.body.classList.remove('index-map-page-active')
  },
  methods: {
    init () { },
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}压力管理系统`)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
</style>

<style lang="less">
/* 仅在压力地图页关闭主内容区滚动，避免右侧滚动条出现 */
body.index-map-page-active .ant-pro-basicLayout > .ant-layout.sidemenu,
body.index-map-page-active .ant-pro-basicLayout > .ant-layout.topmenu,
body.index-map-page-active .ant-pro-basicLayout-content.ant-layout-content {
  overflow: hidden !important;
}
</style>
